import React from "react";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import LoadingIcons from "react-loading-icons";

interface Member {
  id: string;
  user_id: string | null;
  email: string;
  name?: string;
  role: string;
  status: string;
  created_at: string;
}

interface EditRoleModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  editingMember: Member | null;
  editMemberRole: string;
  setEditMemberRole: (role: string) => void;
  editRoleError: string | null;
  editRoleLoading: boolean;
  onUpdateRole: () => void;
}

const EditRoleModal: React.FC<EditRoleModalProps> = ({
  isOpen,
  setIsOpen,
  editingMember,
  editMemberRole,
  setEditMemberRole,
  editRoleError,
  editRoleLoading,
  onUpdateRole,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 sm:mt-0 text-left w-full">
          <h3 className="text-lg font-semibold leading-6 text-gray-900 mb-4">
            Edit member access
          </h3>

          {editRoleError && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4"
              role="alert"
            >
              {editRoleError}
            </div>
          )}

          {editingMember && (
            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-4">
                Changing role for{" "}
                <span className="font-medium text-gray-900">
                  {editingMember.name || editingMember.email}
                </span>
              </p>
              <label
                htmlFor="edit-role"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Role
              </label>
              <select
                id="edit-role"
                value={editMemberRole}
                onChange={(e) => setEditMemberRole(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={editRoleLoading}
              >
                <option value="member">Member</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          )}

          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
            <PrimaryButton
              onClick={onUpdateRole}
              disabled={editRoleLoading}
              className="w-full sm:w-auto"
            >
              {editRoleLoading ? (
                <span className="flex items-center gap-2">
                  <LoadingIcons.TailSpin stroke="#fff" width="16" height="16" />
                  Updating...
                </span>
              ) : (
                "Update Role"
              )}
            </PrimaryButton>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              disabled={editRoleLoading}
              className="mt-3 sm:mt-0 w-full sm:w-auto inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditRoleModal;
